// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IReceiptDocumentFileResponse } from './IReceiptDocumentFileResponse';
import {
    IReceiptDocumentFileResponseFromJSON,
    IReceiptDocumentFileResponseFromJSONTyped,
    IReceiptDocumentFileResponseToJSON,
    IReceiptDocumentFileResponseToJSONTyped,
} from './IReceiptDocumentFileResponse';

/**
 * 
 * @export
 * @interface ICustomPageReceiptDocumentFileResponse
 */
export interface ICustomPageReceiptDocumentFileResponse {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IReceiptDocumentFileResponse>}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    content?: Array<IReceiptDocumentFileResponse>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageReceiptDocumentFileResponse
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageReceiptDocumentFileResponse interface.
 */
export function instanceOfICustomPageReceiptDocumentFileResponse(value: object): value is ICustomPageReceiptDocumentFileResponse {
    return true;
}

export function ICustomPageReceiptDocumentFileResponseFromJSON(json: any): ICustomPageReceiptDocumentFileResponse {
    return ICustomPageReceiptDocumentFileResponseFromJSONTyped(json, false);
}

export function ICustomPageReceiptDocumentFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageReceiptDocumentFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IReceiptDocumentFileResponseFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageReceiptDocumentFileResponseToJSON(json: any): ICustomPageReceiptDocumentFileResponse {
    return ICustomPageReceiptDocumentFileResponseToJSONTyped(json, false);
}

export function ICustomPageReceiptDocumentFileResponseToJSONTyped(value?: ICustomPageReceiptDocumentFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IReceiptDocumentFileResponseToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

